export const delay = (time: number) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  return Buffer.from(buffer).toString('base64');
};
